Attachment = require 'models/attachment'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Dates = require 'lib/dates'

module.exports = class AttachmentList extends CollectionWithHelpers
  model: Attachment

  initialize: (models, options) ->
    @listenTo @, 'change:pos', @sort

  comparator: (attachment) ->
    attachment.get('pos') || (Dates.parse(attachment.get('date')))



// WEBPACK FOOTER //
// ./app/scripts/models/collections/attachment-list.coffee